import { render } from "./HeroiconsOutlineLockOpen.vue?vue&type=template&id=bc2a5a72"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLockOpen.vue"]])

export default __exports__